import { useUserEventLogger } from '@repo/tracking-service';
import { Accordion, AccordionButton, AccordionContent, AccordionItem, AccordionTrigger, MainTitle } from '@repo/ui';
import { FC, useState } from 'react';

export interface FaqResultItem {
  title: string;
  content: string;
}

interface Props {
  data: FaqResultItem[];
  clickEventName: string;
}
type ApplyResultFaqViewProps = Props;

const ApplyResultFaqView: FC<ApplyResultFaqViewProps> = ({ data, clickEventName }) => {
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const { sendClickEvent } = useUserEventLogger();

  const handleSendClickEvent = (index: string) => {
    sendClickEvent(clickEventName, { 'item-no': String(index + 1) });
  };

  const handleAccordionChange = (value: string[]) => {
    const expandedSet = new Set(expandedItems);
    value.forEach((idx) => {
      if (!expandedSet.has(idx)) {
        handleSendClickEvent(idx);
      }
    });
    setExpandedItems(value);
  };

  return (
    <div className={'py-normal-medium px-4.5'}>
      <MainTitle className={'pt-normal-large pb-normal-medium'} title={'자주 묻는 질문'} size={'small'} />

      <Accordion type="multiple" className="w-full" value={expandedItems} onValueChange={handleAccordionChange}>
        {data.map((content, idx) => (
          <AccordionItem key={idx} value={idx.toString()}>
            <AccordionTrigger
              className={
                '!px-0 !py-[12px] text-[15px] hover:no-underline font-semibold [&>svg]:w-[18px] [&>svg]:h-[18px] [&>svg]:text-neutral-foreground-lowest'
              }
            >
              {content.title}
              <AccordionButton type={'chevron-down'} size={18} color={'#8A96A3'} />
            </AccordionTrigger>
            <div className="-mx-3">
              <AccordionContent
                className={`py-4 px-3 text-[14px] caption-medium-regular rounded-2xl bg-neutral-background-lowest text-neutral-foreground-low !pb-normal-medium ${idx === data.length - 1 ? '' : 'mb-[12px]'}`}
              >
                {content.content}
              </AccordionContent>
            </div>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default ApplyResultFaqView;
